module.exports = __webpack_public_path__ + "img/tongGao.a5dc26e2.png";